// **أدوات الترويسة الثانوية في زرٍّ واحد** (قرار المالك 22/09/2026: «مش عايز دول جنب
// بعض كده واخدين مساحة كبيرة جدًّا»).
//
// وليست كلُّ أداةٍ سواءً في اليوم: البحثُ والبصمةُ والجرسُ والخروج تُستعمل مرّاتٍ كل
// يوم، أمّا سعرُ الدولار ولوحةُ الأداء وإرسالُ إعلانٍ وشكلُ الشاشة فتُفتح حين تُطلب.
// **فالأولى تبقى ظاهرة، والثانية خلف زرٍّ واحد** — يوفّر نحو ثلثي عرض الشريط.
//
// **ولا شيءَ يختفي**: كلُّ ما كان في الترويسة باقٍ فيها، بضغطةٍ واحدة. والقائمة تُغلق
// بالضغط خارجها أو بـEsc، وتُفتح إلى جهة المحتوى فلا تخرج عن حافّة الشاشة.
import { useEffect, useRef, useState, type ReactNode } from 'react';

export function HeaderMore({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const box = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    if (!open) return;
    // ونافذةُ الشريط المتحرّك تُرسم خارج هذه القائمة (portal) — فالضغطُ داخل أيّ نافذةٍ مفتوحة
    // ليس «خارجها» (مراجعة 23/09/2026: كان أوّلُ ضغطةٍ في مربّع الإعلان يُغلقه قبل أن يُكتب فيه)
    const away = (e: MouseEvent): void => {
      const t = e.target as Element | null;
      if (box.current?.contains(t as Node) || t?.closest?.('[role="dialog"]')) return;
      setOpen(false);
    };
    const esc = (e: KeyboardEvent): void => { if (e.key === 'Escape') { e.preventDefault(); setOpen(false); } };
    document.addEventListener('mousedown', away);
    window.addEventListener('keydown', esc);
    return () => { document.removeEventListener('mousedown', away); window.removeEventListener('keydown', esc); };
  }, [open]);

  return (
    <span ref={box} className="relative inline-flex">
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open}
        aria-label="أدوات إضافية" title="أدوات إضافية"
        className={`grid h-8 w-8 place-items-center rounded-lg border transition-colors
          ${open
            ? 'border-brand-300 bg-brand-50 text-brand-700'
            : 'border-slate-300 bg-white text-ink-500 hover:border-brand-300 hover:text-brand-700'}`}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"
          aria-hidden="true" className="h-4 w-4">
          <path d="M6 12h.01M12 12h.01M18 12h.01" />
        </svg>
      </button>
      {open && (
        <span className="absolute end-0 top-full z-50 mt-1.5 flex w-max max-w-[22rem] flex-wrap items-center
          justify-end gap-2 rounded-xl border border-slate-200 bg-white p-2 shadow-lg">
          {children}
        </span>
      )}
    </span>
  );
}
